'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var submitCrossDomainForm = exports.submitCrossDomainForm = function submitCrossDomainForm(_ref) {
  var _ref$parent = _ref.parent,
      parent = _ref$parent === undefined ? document.body : _ref$parent,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'POST' : _ref$method,
      message = _ref.message,
      action = _ref.action,
      _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === undefined ? [] : _ref$inputs;

  if (typeof window === 'undefined') {
    throw new Error('Must be run in a browser!');
  }

  var frameEl = document.createElement('iframe');
  var formEl = document.createElement('form');
  var formSubmit = document.createElement('button');

  frameEl.width = 0;
  frameEl.height = 0;
  frameEl.frameBorder = 0;
  frameEl.style.position = 'absolute';
  parent.appendChild(frameEl);

  formEl.action = action;
  formEl.method = method;
  formEl.onsubmit = function (event) {
    return window.parent.postMessage(message, window.location.origin);
  };

  formSubmit.type = 'submit';

  inputs.map(function (attrs) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = attrs.name;
    input.value = attrs.value;
    return formEl.appendChild(input);
  });

  formEl.appendChild(formSubmit);

  var isDomReady = setInterval(function () {
    var button = frameEl.contentDocument.querySelector('button');

    if (button) {
      clearInterval(isDomReady);
      return button.click();
    } else {
      frameEl.contentDocument.body.appendChild(formEl);
    }
  }, 50);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/cross-domain/index.js
// module id = 1379
// module chunks = 0